import { useAppDispatch } from "../../../redux";
import { useTranslation } from "react-i18next";

import {
  searchLoadSurvey,
  updatePageIndex,
} from "../../../redux/reducer/surveyHistoryReducer";
import InputSearch from "../../prenotationfilterBox/inputSearch";
import { useParams } from "react-router-dom";

const SurveyHistorySearchBox = () => {
  const { t } = useTranslation();
  /**
   * Get url params.
   */
  const { id } = useParams();

  const dispatch = useAppDispatch();
  const setSearch = (input: string) => {
    dispatch(updatePageIndex(1));
    dispatch(searchLoadSurvey(input, id));
  };

  return (
    <div className="container-box">
      <div className="content survey-filter-box p-0">
        <div className="Filter">
          <div className="row m-0">
            <div className="col-lg-8 pt-4">
              <strong>{t("survey-history-table-headline")}</strong>
            </div>
            <div className="col-lg-4 pt-4 text-lg-right">
              <InputSearch
                placeholder={t("search-survey")}
                handleClick={(e: any) => {
                  setSearch(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyHistorySearchBox;
